import { graphql } from "src/graphql/generated";

export const campaignInquiriesQuery = graphql(/* GraphQL */ `
    query CampaignInquiries($client: String!, $resolved: Boolean, $limit: Int, $nextToken: String) {
        campaignInquiries(client: $client, resolved: $resolved, limit: $limit, nextToken: $nextToken) {
            nextToken
            items {
                ...campaignInquiryItemFields
            }
        }
    }
`);

export const campaignInquiryQuery = graphql(/* GraphQL */ `
    query CampaignInquiry($campaignInquiryId: String!) {
        campaignInquiry(campaignInquiryId: $campaignInquiryId) {
            ...campaignInquiryDetailFields
        }
    }
`);
